export const engineerBookingMock = {
  status: 'OK',
  result: {
    Status: 'OK',
    StatusCode: 'PS000',
    StatusDebugging: [],
    PaymentRequired: false,
    PaymentData: [],
    ExtraAvailability: true,
    AvailabilityRequestDays: 14,
    AvailabilityMaximumDays: 14,
    AvailabilityStartDate: '2025-07-28',
    AvailabilityEndDate: '2025-08-03',
    AvailabilityData: [
      {
        Date: '2025-07-28',
        Slots: [
          {
            Identifier: '1373_20250728_AM',
            SlotType: 'AM',
            StartTime: '',
            EndTime: '',
            Available: true,
          },
        ],
      },
      {
        Date: '2025-07-29',
        Slots: [
          {
            Identifier: '1373_20250729_AM',
            SlotType: 'AM',
            StartTime: '',
            EndTime: '',
            Available: true,
          },
        ],
      },
      {
        Date: '2025-07-30',
        Slots: [
          {
            Identifier: '1373_20250730_AM',
            SlotType: 'AM',
            StartTime: '',
            EndTime: '',
            Available: true,
          },
        ],
      },
      {
        Date: '2025-07-31',
        Slots: [
          {
            Identifier: '1373_20250731_AM',
            SlotType: 'AM',
            StartTime: '',
            EndTime: '',
            Available: true,
          },
        ],
      },
      {
        Date: '2025-08-01',
        Slots: [
          {
            Identifier: '1373_20250801_AM',
            SlotType: 'AM',
            StartTime: '',
            EndTime: '',
            Available: true,
          },
        ],
      },
      {
        Date: '2025-08-02',
        Slots: [
          {
            Identifier: '1373_20250802_AM',
            SlotType: 'AM',
            StartTime: '',
            EndTime: '',
            Available: true,
          },
        ],
      },
      {
        Date: '2025-08-03',
        Slots: [
          {
            Identifier: '1373_20250803_AM',
            SlotType: 'AM',
            StartTime: '',
            EndTime: '',
            Available: true,
          },
        ],
      },
    ],
    ServiceProviders: [],
  },
};
